const AUTH_TOKEN_KEY = 'admin_auth_token';
const AUTH_USER_KEY = 'admin_auth_user';

const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL || '/api').replace(/\/$/, '');

function getAuthStorage() {
  return localStorage.getItem(AUTH_TOKEN_KEY) ? localStorage : sessionStorage;
}

export function getAuthToken() {
  return localStorage.getItem(AUTH_TOKEN_KEY) || sessionStorage.getItem(AUTH_TOKEN_KEY);
}

export function getAuthUser() {
  const raw = localStorage.getItem(AUTH_USER_KEY) || sessionStorage.getItem(AUTH_USER_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function setAuthSession({ token, user, remember }) {
  const storage = remember ? localStorage : sessionStorage;
  const clearStorage = remember ? sessionStorage : localStorage;

  clearStorage.removeItem(AUTH_TOKEN_KEY);
  clearStorage.removeItem(AUTH_USER_KEY);

  storage.setItem(AUTH_TOKEN_KEY, token);
  storage.setItem(AUTH_USER_KEY, JSON.stringify(user));
}

export async function loginWithPassword({ phone, password, remember }) {
  const response = await fetch(`${API_BASE_URL}/auth/admin/login`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ phone, password })
  });

  const payload = await response.json().catch(() => ({}));

  if (!response.ok) {
    const validationErrors = payload.errors && typeof payload.errors === 'object' ? Object.values(payload.errors).flat() : [];
    const errorMessage = validationErrors[0] || payload.message || 'Login failed';
    throw new Error(errorMessage);
  }

  setAuthSession({ token: payload.token, user: payload.user, remember });
  return payload;
}

export async function logoutSession() {
  const token = getAuthToken();
  if (token) {
    try {
      await fetch(`${API_BASE_URL}/auth/logout`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${token}`
        }
      });
    } catch {
      // Ignore network/logout errors and clear local session regardless.
    }
  }

  localStorage.removeItem(AUTH_TOKEN_KEY);
  localStorage.removeItem(AUTH_USER_KEY);
  sessionStorage.removeItem(AUTH_TOKEN_KEY);
  sessionStorage.removeItem(AUTH_USER_KEY);
}

export async function fetchCurrentUser() {
  const token = getAuthToken();
  if (!token) return null;

  let response;
  try {
    response = await fetch(`${API_BASE_URL}/auth/me`, {
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${token}`
      }
    });
  } catch {
    return null;
  }

  if (!response.ok) return null;
  const user = await response.json();
  getAuthStorage().setItem(AUTH_USER_KEY, JSON.stringify(user));
  return user;
}
